import * as angular from 'angular';

angular
  .module('bringoz.admin.billing-accounts', [
    'bringoz.admin.commons'
  ]);
